var path = 'views/templates/fileSelect.html';
var html = "<div class=\"file-input-wrapper\" ng-style=\"{ 'display': !hasCreatePermission && 'none' }\"> <input type=\"file\" name=\"file\"/> <div ng-transclude></div> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;